import { useEffect } from "react";
import styled from "styled-components";
import { useCatalogRoute } from "../../contexts/CatalogRouteContext";
import ShareButton from "../share/ShareButton";

const VIMEO_PLAYER = 'https://player.vimeo.com/video/';
const PORTAL_CONTENT = `${process.env.REACT_APP_TS_URL}/api/portal-content/`;

/**
 * Documento de una solución: imagen, PDF o video.
 *
 * Abierto o cerrado lo decide la URL (el último segmento), no el JS de Bootstrap:
 * de esa forma un documento se puede compartir con un link, y el botón Atrás del
 * navegador lo cierra.
 *
 * Al cerrarse el iframe se desmonta, así que el video se corta solo. Antes eso
 * se hacía reasignando el src a mano al escuchar 'hidden.bs.modal'.
 */
export default function Modal({ doc, solution }) {
    const { docId, openDoc, closeDoc } = useCatalogRoute();

    const isOpen = docId === doc.id;
    const isVideo = doc.type === 'video';
    const src = isVideo ? VIMEO_PLAYER + doc.attachment : PORTAL_CONTENT + doc.id;

    const handleClose = () => closeDoc(solution);

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') handleClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }); // sin deps: handleClose depende del render actual

    return (
        <StyledModal>
            <button type="button" className="btn btn-warning" onClick={() => openDoc(solution, doc)}>
                {doc.name}
            </button>

            {isOpen && (
                <div className="modal fade show d-block" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5">{doc.name}</h1>
                                <div className="headerActions">
                                    <ShareButton title={doc.name} label="Compartir" />
                                    <button type="button" className="btn-close" aria-label="Cerrar documento" onClick={handleClose}></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                {isVideo ? (
                                    <div className="containerVideo">
                                        <iframe
                                            className="video"
                                            title={doc.name}
                                            src={src}
                                            frameBorder="0"
                                            allow="autoplay; fullscreen; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                ) : doc.type === 'pdf' ? (
                                    <iframe title={doc.name} src={src} frameBorder="0" className="documento"></iframe>
                                ) : (
                                    <img src={src} alt={doc.name} />
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </StyledModal>
    );
}

const StyledModal = styled.div`
    .headerActions {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }
    .modal-body {
        width: 100%;
        display: flex;
        justify-content: center;
    }
    img {
        max-width: 100%;
    }
    .documento {
        width: 100%;
        height: 75vh;
    }
    .containerVideo{
        width: 100%;
        aspect-ratio: 16 / 9;

        .video {
            width: 100%;
            height: 100%;
        }
    }
`;
